import { h } from 'vue';
import { i18n } from '@/config';

export default {
  props: {
    repeat: { type: Number, default: 1 },
    text: String,
    className: { type: String, default: '' },
  },
  render() {
    const items = [];
    const title = this.text || i18n.global.t('report.watermarkLabel');

    for (let i = 1; i <= this.repeat; i++) {
      items.push(h('div', {
        key: i,
        class: `watermark font-small ${this.className}`,
      }, title));
    }

    return items;
  },
};
